import get from 'lodash/get';
import startCase from 'lodash/startCase';
import lowerCase from 'lodash/lowerCase';
import {findSection} from 'ducks/reportSections';

export const getTrackableSectionNames = (payload, reportSections, reportType) => {
  return get(payload, 'sections', []).map(s => {
    const value = startCase(lowerCase(s.name));
    if (s.name === 'CUSTOM') {
      const section = findSection(reportSections, reportType, 'CUSTOM', s.pdf);
      return `${value} - ${section.uiLabel}`;
    } else if (s.name === 'COMPARABLE_MAP') {
      return 'Comps. Map: All';
    } else if (s.name === 'COMPARABLE_SALES_MAP') {
      return 'Comps. Map: Sales';
    } else if (s.name === 'COMPARABLE_LISTINGS_MAP') {
      return 'Comps. Map: Listings';
    } else if (s.name === 'COMPARABLE_RENTALS_MAP') {
      return 'Comps. Map: Rentals';
    }
    return value;
  });
};